import { axiosInstance } from ".."

const projectAttachementSubCategories = async (id) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/pm/subCategories/${id}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default projectAttachementSubCategories;